import { Typography } from 'antd';
import React from 'react';
import { formatCurrency } from '~/utils/currency';
import { UserOutlined } from '@ant-design/icons';
import clsx from 'clsx';

import i18n from '~/i18n';
import { useNavigate } from 'react-router-dom';
import { Order } from '@restaurant/api';
import { ORDER_TYPE_TEXT } from '@restaurant/constants';
import { formatTime } from '~/utils/time';
import { OrderType } from '@restaurant/types';

const { Text } = Typography;

const OrderItemRow = ({ order }: { order: Order }) => {
  const firstRow = (() => {
    if (order.orderType === OrderType.Indent) {
      const deliveryDateTimeStr = (() => {
        const { date, time } = order.delivery?.deliveryDateTime ?? {};
        return [date, time].filter(Boolean).join(' ') ?? '-';
      })();

      return [ORDER_TYPE_TEXT[order.orderType], deliveryDateTimeStr].join(
        ' - '
      );
    }

    return [
      ORDER_TYPE_TEXT[order.orderType],
      order.tableNumber
        ? i18n.t('order_info_table_no', { no: order.tableNumber })
        : null,
    ]
      .filter((val) => val)
      .join(' - ');
  })();

  const customerText = (() => {
    if (order.orderType === OrderType.Indent) {
      const { recipientName, mobileCountryCode, mobileNumber } =
        order.delivery ?? {};
      const phoneNumberStr = [mobileCountryCode, mobileNumber]
        .filter(Boolean)
        .join(' ');
      return [recipientName, phoneNumberStr].join(' ');
    }

    return order.customerName;
  })();

  const navigate = useNavigate();

  const onClick = () => {
    navigate(`${order.orderId}`);
  };

  const bgColor = (() => {
    if (
      order.batches.every((batch) => {
        return batch.every((item) => item.isChecked);
      })
    ) {
      return 'bg-red-100';
    }
    if (
      order.batches.some((batch) => {
        return batch.some((item) => item.isChecked);
      })
    ) {
      return 'bg-yellow-100';
    }
    return 'bg-white';
  })();

  return (
    <div
      className={clsx('w-full px-4 py-2 cursor-pointer', bgColor)}
      onClick={onClick}
      style={{ borderBottom: '1px solid #eee' }}
    >
      <div className="flex justify-between items-center text-xs text-neutral-500">
        <p>{`No: ${order.orderNumber}`}</p>
        <p>{`Created at ${formatTime(order.dateCreated)}`}</p>
      </div>
      <div className="flex justify-between">
        <p className="text-base font-medium">{firstRow}</p>
      </div>
      <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center">
          <UserOutlined style={{ marginRight: 4 }} />
          <p>{customerText ?? '-'}</p>
        </div>
        <Text>{formatCurrency(order.totalPrice)}</Text>
      </div>
    </div>
  );
};

export default OrderItemRow;
